import apiClient from './client';

export const CustomIcdAxiosInstance = apiClient;